import { QueryClient } from "@tanstack/react-query";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // set a global default staleTime of 30 seconds to prevent refetches on every window refocus
      staleTime: 1000 * 30,
    },
  },
});

export default queryClient;
